import { ProfileRoleTYPE } from './../../api/plyca-dtos';
import {
  Component,
  AfterContentInit,
  OnDestroy,
  ViewChild
} from '@angular/core';

import { ServiceLocator } from '../../ServiceLocator';
import { TranslateService } from '@ngx-translate/core';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { generateRandomIdentifier } from '../../ui.service';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng-lts/dynamicdialog';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { PlycaDataService } from '../../../services/plyca.service';
import { Configuration } from '../../conf/app.constants';
import { catchError, finalize, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { deNormalizaDossierId, ProtocolDTO } from '../../api/plyca-dtos';
import { FormConfig } from '../../components/forms/form.objects';
import { formPlycaComponent } from '../../components/forms/formPlyca.component';


@Component({
  selector: 'longtext-editor',
  templateUrl: 'protocolEvaluate.template.html',
  providers: [DialogService]
})
export class ProtocolEvaluateComponent extends BaseComponent implements AfterContentInit, OnDestroy {



  windowHash: string;
  loaded = false;


  context: any;
  disabled: boolean;
  maxLong: number;

  propuestaId: string;
  result: any;
  resultList: any;
  protocol: ProtocolDTO;

  formConfig: FormConfig;
  @ViewChild('tplResultForm') resultForm: formPlycaComponent;


  constructor(public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    private configuration: Configuration,
    private plycaService: PlycaDataService,
    private plycaErrorHandler: PlycaErrorHandler,
    private translate: TranslateService,
    private headerActionsService: HeaderActionsService,
    private waitService: WaitLoadingService) {

    super();


    this.protocol = dialogConfig['protocol'];

    this.load();

  }

  load() {
    this.loaded = true;
  }

  ngAfterContentInit(): void {
    this.waitService.startWaiting();
    this.windowHash = generateRandomIdentifier();
    this.headerActionsService.clearWindowActions(this.windowHash);




    this.subscribe(this.headerActionsService.addWindowAction(
      'Actions.execute',
      'fas fa-play',
      'btn-primary',
      true, this.windowHash
    ), success => {


      this.subscribe(
        this.plycaService.get(
          this.configuration.PROTOCOL_SERVICE_URL + 'evaluate/',
          deNormalizaDossierId(this.propuestaId),
          {

          }).pipe(
            tap((result: ProtocolDTO) => {
              this.result = {};
              this.result['dto'] = result;
              this.result['dto'].protocolProfiles.map(
                (element: any) => {
                  element['profileRoleDescription'] = element.profileRole === ProfileRoleTYPE.DISPATCHER ?
                    this.translate.instant('ControlPanel.protocols.profiles.dispatchers')
                    : this.translate.instant('ControlPanel.protocols.profiles.signers');
                  return element
                })
            }),
            catchError((error: any) => {
              this.plycaErrorHandler.showServerError(error);
              return throwError(error);
            }),
            finalize(() => {
              this.waitService.cancelWaiting();
            }
            )
          )
      )


    });





    this.subscribe(this.headerActionsService.addWindowAction(
      'General.close',
      'fas fa-times',
      'btn-outline-secondary',
      true, this.windowHash
    ), success => {
      this.ref.close();
    });
    this.waitService.cancelWaiting();
  }


  ngOnDestroy() {
    this.headerActionsService.clearWindowActions(this.windowHash);
    // this.dialogConfig = null;
    // this.ref = null;
    super.ngOnDestroy();
  }



  public isLoaded() { return this.loaded; }
}
